import { applyMiddleware, createStore as createStoreRedux } from 'redux';
import { enableBatching } from 'redux-batched-actions';
import { createEpicMiddleware } from 'redux-observable';
import { debugEnabled } from '@atlassian/jira-common-debug';
import composeWithDevtools from '@atlassian/jira-common-util-compose-with-devtools';
import reducer from './reducer';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createStore = (rootOperation: any, initialState: any, middlewares = []) =>
	createStoreRedux(
		enableBatching(reducer),
		initialState,
		composeWithDevtools({ name: 'Project Details' })(
			applyMiddleware(...middlewares, createEpicMiddleware(rootOperation)),
		),
	);

// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
export default (rootOperation: any) => {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const middlewares: any = [];

	if (debugEnabled('redux-logger')) {
		// include logger only for development environment
		// eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires
		const { logger } = require('redux-logger');
		middlewares.push(logger);
	}

	return createStore(rootOperation, undefined, middlewares);
};
